export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  JSON: { input: any; output: any }
  Time: { input: any; output: any }
  UUID: { input: any; output: any }
  Upload: { input: any; output: any }
}

/**
 * Result of an add-to-cart. `added` is false when the material was already in the cart
 * under the same project — the cart comes back unchanged and no sample was ordered, which
 * is what lets callers skip reporting an add that did not happen.
 */
export type AddCartItemResult = {
  __typename?: 'AddCartItemResult'
  added: Scalars['Boolean']['output']
  cart: Cart
}

export type AddToCartInput = {
  price: InputMaybe<Scalars['Float']['input']>
  productName: InputMaybe<Scalars['String']['input']>
  projectId: InputMaybe<Scalars['ID']['input']>
  sku: Scalars['String']['input']
  thumbnailUrl: InputMaybe<Scalars['String']['input']>
}

export type Address = {
  __typename?: 'Address'
  address: Scalars['String']['output']
  city: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  regionCode: Scalars['String']['output']
  zip: Scalars['String']['output']
}

export type AddressSuggestion = {
  __typename?: 'AddressSuggestion'
  address: Scalars['String']['output']
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  key: Scalars['String']['output']
  region: Scalars['String']['output']
  zip: Scalars['String']['output']
}

/** The Token type used for authentication. */
export type AuthToken = {
  __typename?: 'AuthToken'
  token: Scalars['String']['output']
}

export type Brand = {
  __typename?: 'Brand'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  ref: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type BrandConfig = {
  __typename?: 'BrandConfig'
  contactOptions: ContactOptions
  contactRecipients: ContactRecipients
  productRetirement: ProductRetirement
  redirectUrl: Scalars['String']['output']
}

export type BrandConfigInput = {
  contactOptions: InputMaybe<ContactOptionsInput>
  contactRecipients: InputMaybe<ContactRecipientsInput>
  productRetirement: InputMaybe<ProductRetirementInput>
}

export type BrandRep = {
  __typename?: 'BrandRep'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  phone: Maybe<Scalars['String']['output']>
  photo: Maybe<Scalars['String']['output']>
}

export type Cart = {
  __typename?: 'Cart'
  id: Scalars['ID']['output']
  itemCount: Scalars['Int']['output']
  items: Array<CartItem>
  shippingCost: Scalars['Float']['output']
  subtotal: Scalars['Float']['output']
  tax: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export type CartItem = {
  __typename?: 'CartItem'
  brandName: Scalars['String']['output']
  id: Scalars['ID']['output']
  isBookmarked: Scalars['Boolean']['output']
  isOutOfStock: Scalars['Boolean']['output']
  isShippingNormal: Scalars['Boolean']['output']
  price: Scalars['Float']['output']
  productName: Scalars['String']['output']
  project: Maybe<CartProject>
  quantity: Scalars['Int']['output']
  sku: Scalars['String']['output']
  thumbnailUrl: Scalars['String']['output']
}

export type CartProject = {
  __typename?: 'CartProject'
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type City = {
  __typename?: 'City'
  countryCode: Scalars['String']['output']
  countryId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  name: Scalars['String']['output']
  stateCode: Scalars['String']['output']
  stateId: Maybe<Scalars['Int']['output']>
}

export type CityCollection = {
  __typename?: 'CityCollection'
  currentPage: Scalars['Int']['output']
  items: Array<City>
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type CollectionParams = {
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
}

/**
 * What the browser needs to call Constructor recommendations as the current
 * caller: their identity and their entitlement filters. Only ever the caller's
 * own data.
 */
export type ConstructorUserContext = {
  __typename?: 'ConstructorUserContext'
  /** The block list, sent as a `pre_filter_expression` exclusion. */
  excludedRuleGroupIds: Maybe<Array<Scalars['String']['output']>>
  /**
   * True when the filters are the public-only fallback from a failed entitlement
   * lookup, or a member's id couldn't be resolved. The browser must not cache or
   * use such a context: the BFF retries the lookup on every request.
   */
  isDegraded: Scalars['Boolean']['output']
  isMember: Scalars['Boolean']['output']
  /** The `brg_id` inclusion filter. Null means no filter (guests). */
  ruleGroupIds: Maybe<Array<Scalars['String']['output']>>
  /** Sent to Constructor as `ui`. Null for guests, or when the lookup fails. */
  userId: Maybe<Scalars['String']['output']>
}

export type ContactOptions = {
  __typename?: 'ContactOptions'
  call: Scalars['Boolean']['output']
  leadTime: Scalars['Boolean']['output']
  other: Scalars['Boolean']['output']
  pricing: Scalars['Boolean']['output']
  text: Scalars['Boolean']['output']
}

export type ContactOptionsInput = {
  call: Scalars['Boolean']['input']
  leadTime: Scalars['Boolean']['input']
  other: Scalars['Boolean']['input']
  pricing: Scalars['Boolean']['input']
  text: Scalars['Boolean']['input']
}

export enum ContactRecipientMode {
  Default = 'DEFAULT',
  GeneralContact = 'GENERAL_CONTACT',
}

export type ContactRecipients = {
  __typename?: 'ContactRecipients'
  email: Maybe<Scalars['String']['output']>
  mode: ContactRecipientMode
  phoneNumber: Maybe<Scalars['String']['output']>
}

export type ContactRecipientsInput = {
  email: InputMaybe<Scalars['String']['input']>
  mode: ContactRecipientMode
  phoneNumber: InputMaybe<Scalars['String']['input']>
}

export type Coordinates = {
  __typename?: 'Coordinates'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type CoordinatesInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type Country = {
  __typename?: 'Country'
  capital: Scalars['String']['output']
  cities: Array<City>
  code: Scalars['String']['output']
  currency: Maybe<Scalars['String']['output']>
  currencyName: Maybe<Scalars['String']['output']>
  currencySymbol: Maybe<Scalars['String']['output']>
  emoji: Maybe<Scalars['String']['output']>
  emojiU: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  iso3: Scalars['String']['output']
  latitude: Maybe<Scalars['Float']['output']>
  longitude: Maybe<Scalars['Float']['output']>
  name: Scalars['String']['output']
  native: Maybe<Scalars['String']['output']>
  numericCode: Scalars['String']['output']
  phoneCode: Maybe<Scalars['String']['output']>
  region: Maybe<Scalars['String']['output']>
  states: Array<State>
  subregion: Maybe<Scalars['String']['output']>
}

export type CountryCollection = {
  __typename?: 'CountryCollection'
  currentPage: Scalars['Int']['output']
  items: Array<Country>
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type CreateProjectUser = {
  email: Scalars['String']['input']
  type: ProjectUserType
}

export type CurrentUser = {
  __typename?: 'CurrentUser'
  activeProjectId: Maybe<Scalars['String']['output']>
  avatarUrl: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  jobTitle: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  organizationName: Maybe<Scalars['String']['output']>
  phone: Maybe<Scalars['String']['output']>
}

export type Dashboard = {
  __typename?: 'Dashboard'
  kpisByType: Array<DashboardKpiValue>
  metrics: Array<DashboardMetric>
  tags: Array<TagPin>
  topProductsByEvents: Array<TopProduct>
}

export type DashboardKpisByTypeArgs = {
  kpis: Array<DashboardKpi>
}

export type DashboardMetricsArgs = {
  input: Array<DashboardMetricInput>
}

export type DashboardTopProductsByEventsArgs = {
  events: Array<Scalars['String']['input']>
  limit?: Scalars['Int']['input']
}

export type DashboardInput = {
  activationEvents: Array<Scalars['String']['input']>
  brandRef: Scalars['String']['input']
  filterKey: InputMaybe<Scalars['String']['input']>
  timeframe: TimeframeInput
}

export enum DashboardKpi {
  ActivatedTags = 'ACTIVATED_TAGS',
  TagsInCirculation = 'TAGS_IN_CIRCULATION',
  TapsPerActivatedTag = 'TAPS_PER_ACTIVATED_TAG',
}

export type DashboardKpiValue = {
  __typename?: 'DashboardKpiValue'
  kpi: DashboardKpi
  value: KpiMetric
}

export type DashboardMetric = {
  __typename?: 'DashboardMetric'
  key: Scalars['String']['output']
  value: DashboardMetricValue
}

export type DashboardMetricInput = {
  events: Array<Scalars['String']['input']>
  key: Scalars['String']['input']
}

export type DashboardMetricValue = {
  __typename?: 'DashboardMetricValue'
  current: Scalars['Float']['output']
  delta: Scalars['Float']['output']
  previous: Scalars['Float']['output']
}

export type DashboardTagProduct = {
  __typename?: 'DashboardTagProduct'
  activatedAt: Scalars['Time']['output']
  address: Scalars['String']['output']
  city: Scalars['String']['output']
  color: Scalars['String']['output']
  company: Scalars['String']['output']
  country: Scalars['String']['output']
  image: Scalars['String']['output']
  member: Scalars['String']['output']
  name: Scalars['String']['output']
  orderAt: Scalars['Time']['output']
  productRef: Scalars['String']['output']
  state: Scalars['String']['output']
  tagRef: Scalars['String']['output']
  tapCount: Scalars['Int']['output']
  zip: Scalars['String']['output']
}

export type DashboardTagProductsInput = {
  activationEvents: Array<Scalars['String']['input']>
  brandRef: Scalars['String']['input']
  tagRefs: Array<Scalars['String']['input']>
}

export type IntRange = {
  __typename?: 'IntRange'
  from: Scalars['Int']['output']
  to: Maybe<Scalars['Int']['output']>
  unit: Scalars['String']['output']
}

export type IntRangeInput = {
  from: Scalars['Int']['input']
  to: InputMaybe<Scalars['Int']['input']>
  unit: Scalars['String']['input']
}

export enum ItemSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum ItemSortableField {
  Brand = 'BRAND',
  Name = 'NAME',
  Price = 'PRICE',
}

export enum ItemStatus {
  Approved = 'APPROVED',
  Considering = 'CONSIDERING',
  Rejected = 'REJECTED',
  Shortlist = 'SHORTLIST',
}

export type KpiMetric = {
  __typename?: 'KpiMetric'
  delta: Scalars['Float']['output']
  value: Scalars['Int']['output']
}

export type Location = {
  __typename?: 'Location'
  code: Scalars['String']['output']
  coordinates: Coordinates
  isAccurate: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type LocationInput = {
  code: Scalars['String']['input']
  name: InputMaybe<Scalars['String']['input']>
}

export type MemberSuggestion = {
  __typename?: 'MemberSuggestion'
  email: Scalars['String']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
}

export enum MessageEventType {
  MessageAdded = 'MESSAGE_ADDED',
  MessageDeleted = 'MESSAGE_DELETED',
  MessageUpdated = 'MESSAGE_UPDATED',
}

/** Reusable message definitions */
export type MessageUser = {
  __typename?: 'MessageUser'
  firstName: Scalars['String']['output']
  imageUrl: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  userRef: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  Auth: Maybe<AuthToken>
  _empty: Maybe<Scalars['String']['output']>
  addCartItem: AddCartItemResult
  bulkUpdateProductReplacements: Array<ProductReplacement>
  createNote: Note
  createProject: Project
  createProjectUser: ProjectUser
  deleteNote: Note
  deleteProject: Project
  deleteProjectUser: ProjectUser
  deleteSampledItemTag: SampledItemTag
  evaluateTypes: Array<Type>
  patchProject: Project
  readNotes: Scalars['Boolean']['output']
  recordTap: RecordTapResponse
  removeCartItem: Cart
  renameSampledItemTag: SampledItemTag
  saveProduct: SaveStatus
  tagTap: Maybe<Tag>
  toggleCartItemBookmark: Cart
  transferProject: Project
  unsaveProduct: SaveStatus
  updateBrandConfig: BrandConfig
  updateCartItem: Cart
  updateNote: Note
  updateProjectUser: ProjectUser
  updateSampledItem: SampledItem
  updateSampledItemStatus: SampledItem
  updateTapLocation: UpdateTapLocationResponse
}

export type MutationAuthArgs = {
  exToken: Scalars['String']['input']
}

export type MutationAddCartItemArgs = {
  input: AddToCartInput
}

export type MutationBulkUpdateProductReplacementsArgs = {
  brandRef: Scalars['String']['input']
  input: Array<UpdateProductReplacementInput>
}

export type MutationCreateNoteArgs = {
  note: Scalars['String']['input']
  projectID: Scalars['UUID']['input']
}

export type MutationCreateProjectArgs = {
  input: ProjectInput
}

export type MutationCreateProjectUserArgs = {
  input: CreateProjectUser
  projectID: Scalars['UUID']['input']
}

export type MutationDeleteNoteArgs = {
  noteID: Scalars['UUID']['input']
}

export type MutationDeleteProjectArgs = {
  id: Scalars['UUID']['input']
}

export type MutationDeleteProjectUserArgs = {
  id: Scalars['UUID']['input']
}

export type MutationDeleteSampledItemTagArgs = {
  tagID: Scalars['UUID']['input']
}

export type MutationPatchProjectArgs = {
  id: Scalars['UUID']['input']
  input: ProjectInput
}

export type MutationReadNotesArgs = {
  projectID: Scalars['UUID']['input']
}

export type MutationRecordTapArgs = {
  input: RecordTapInput
}

export type MutationRemoveCartItemArgs = {
  itemId: Scalars['ID']['input']
}

export type MutationRenameSampledItemTagArgs = {
  name: Scalars['String']['input']
  tagID: Scalars['UUID']['input']
}

export type MutationSaveProductArgs = {
  variantSku: Scalars['String']['input']
}

export type MutationTagTapArgs = {
  fingerprint: Scalars['UUID']['input']
  location: InputMaybe<CoordinatesInput>
  nonce: Scalars['String']['input']
  tagRef: Scalars['String']['input']
}

export type MutationToggleCartItemBookmarkArgs = {
  itemId: Scalars['ID']['input']
}

export type MutationTransferProjectArgs = {
  id: Scalars['UUID']['input']
  projectUserID: Scalars['UUID']['input']
}

export type MutationUnsaveProductArgs = {
  variantSku: Scalars['String']['input']
}

export type MutationUpdateBrandConfigArgs = {
  brandRef: Scalars['String']['input']
  input: BrandConfigInput
}

export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput
}

export type MutationUpdateNoteArgs = {
  note: Scalars['String']['input']
  noteID: Scalars['UUID']['input']
}

export type MutationUpdateProjectUserArgs = {
  id: Scalars['UUID']['input']
  input: UpdateProjectUser
}

export type MutationUpdateSampledItemArgs = {
  input: UpdateSampledItemInput
  itemID: Scalars['UUID']['input']
}

export type MutationUpdateSampledItemStatusArgs = {
  itemID: Scalars['UUID']['input']
  status: ItemStatus
}

export type MutationUpdateTapLocationArgs = {
  input: UpdateTapLocationInput
}

export type Note = {
  __typename?: 'Note'
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  note: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
  user: Maybe<MessageUser>
}

export type NoteEvent = {
  __typename?: 'NoteEvent'
  note: Note
  type: MessageEventType
}

export type NoteSummary = {
  __typename?: 'NoteSummary'
  hasNewNotes: Scalars['Boolean']['output']
  projectID: Scalars['UUID']['output']
}

export type Order = {
  __typename?: 'Order'
  createdAt: Scalars['String']['output']
  customerId: Scalars['String']['output']
  hostOrderId: Scalars['ID']['output']
  itemCount: Scalars['Int']['output']
  lineItems: Array<OrderLineItem>
  orderNumber: Scalars['String']['output']
  orderStatus: Scalars['String']['output']
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem'
  brandName: Maybe<Scalars['String']['output']>
  images: Maybe<Array<OrderLineItemImage>>
  lineItemId: Scalars['ID']['output']
  name: Scalars['String']['output']
  productSKU: Scalars['String']['output']
  projectId: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
  variantSKU: Scalars['String']['output']
}

export type OrderLineItemImage = {
  __typename?: 'OrderLineItemImage'
  imageContext: Maybe<Scalars['String']['output']>
  imageURL: Scalars['String']['output']
}

export type PairsWithProduct = {
  __typename?: 'PairsWithProduct'
  brand: Maybe<Scalars['String']['output']>
  category: Scalars['String']['output']
  groupId: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageUrl: Scalars['String']['output']
  installImageUrl: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  searchHexCode: Maybe<Scalars['String']['output']>
}

export type PairsWithProductsResult = {
  __typename?: 'PairsWithProductsResult'
  products: Array<PairsWithProduct>
  totalCount: Scalars['Int']['output']
}

export type Phase = {
  __typename?: 'Phase'
  code: Scalars['String']['output']
  label: Scalars['String']['output']
  order: Scalars['Int']['output']
}

export type PhaseInput = {
  code: Scalars['String']['input']
  label: InputMaybe<Scalars['String']['input']>
}

export type Product = {
  __typename?: 'Product'
  brand: Scalars['String']['output']
  category: Scalars['String']['output']
  collection: Maybe<Scalars['String']['output']>
  color: Maybe<Scalars['String']['output']>
  imageUrl: Scalars['String']['output']
  manufacturerSku: Scalars['String']['output']
  name: Scalars['String']['output']
  price: Scalars['String']['output']
  productRef: Scalars['String']['output']
  url: Maybe<Scalars['String']['output']>
}

export type ProductByVariantSkusAttribute = {
  __typename?: 'ProductByVariantSkusAttribute'
  name: Scalars['String']['output']
  value: Maybe<Scalars['String']['output']>
}

export type ProductByVariantSkusCategory = {
  __typename?: 'ProductByVariantSkusCategory'
  categoryId: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  name: Maybe<Scalars['String']['output']>
  parentCategoryId: Maybe<Scalars['String']['output']>
  slug: Maybe<Scalars['String']['output']>
}

export type ProductByVariantSkusDocument = {
  __typename?: 'ProductByVariantSkusDocument'
  contentType: Scalars['String']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  uri: Scalars['String']['output']
}

export type ProductByVariantSkusImage = {
  __typename?: 'ProductByVariantSkusImage'
  label: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type ProductByVariantSkusResult = {
  __typename?: 'ProductByVariantSkusResult'
  brandRef: Maybe<Scalars['String']['output']>
  categories: Array<ProductByVariantSkusCategory>
  images: Array<ProductByVariantSkusImage>
  masterVariant: Maybe<ProductByVariantSkusVariant>
  masterVariantSKU: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  sku: Scalars['String']['output']
  slug: Maybe<Scalars['String']['output']>
  topAttributes: Array<ProductByVariantSkusTopAttribute>
  variantSKUs: Array<Scalars['String']['output']>
  variants: Array<ProductByVariantSkusVariant>
}

export type ProductByVariantSkusTopAttribute = {
  __typename?: 'ProductByVariantSkusTopAttribute'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ProductByVariantSkusVariant = {
  __typename?: 'ProductByVariantSkusVariant'
  attributes: Array<ProductByVariantSkusAttribute>
  brandName: Maybe<Scalars['String']['output']>
  colorFamily: Maybe<Scalars['String']['output']>
  colorName: Maybe<Scalars['String']['output']>
  documents: Array<ProductByVariantSkusDocument>
  images: Array<ProductByVariantSkusImage>
  productSKU: Maybe<Scalars['String']['output']>
  sku: Maybe<Scalars['String']['output']>
  urlKey: Maybe<Scalars['String']['output']>
}

export type ProductReplacement = {
  __typename?: 'ProductReplacement'
  brandId: Scalars['UUID']['output']
  color: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  picture: Scalars['String']['output']
  productRef: Scalars['String']['output']
  replacementRef: Scalars['String']['output']
  replacementType: ProductReplacementType
  retiredAt: Scalars['Time']['output']
}

export type ProductReplacementCollection = {
  __typename?: 'ProductReplacementCollection'
  allRetiredItemsByProduct: Scalars['Int']['output']
  allRetiredItemsByRedirectUrl: Scalars['Int']['output']
  currentPage: Scalars['Int']['output']
  items: Array<ProductReplacement>
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ProductReplacementCollectionFilters = {
  query: InputMaybe<Scalars['String']['input']>
  replacementType: InputMaybe<ProductReplacementType>
}

export enum ProductReplacementOrderBy {
  Name = 'NAME',
  ReplacementType = 'REPLACEMENT_TYPE',
  RetiredAt = 'RETIRED_AT',
}

export enum ProductReplacementType {
  Product = 'PRODUCT',
  RedirectUrl = 'REDIRECT_URL',
}

export type ProductRetirement = {
  __typename?: 'ProductRetirement'
  mode: ProductRetirementMode
}

export type ProductRetirementInput = {
  mode: ProductRetirementMode
}

export enum ProductRetirementMode {
  Custom = 'CUSTOM',
  RedirectUrl = 'REDIRECT_URL',
}

export type ProductSearchResult = {
  __typename?: 'ProductSearchResult'
  products: Array<SearchedProduct>
  totalResults: Scalars['Int']['output']
}

export type ProductSuggestion = {
  __typename?: 'ProductSuggestion'
  color: Scalars['String']['output']
  image: Scalars['String']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  productRef: Scalars['String']['output']
}

export type Project = {
  __typename?: 'Project'
  archivedAt: Maybe<Scalars['Time']['output']>
  budget: Maybe<IntRange>
  city: Maybe<Scalars['String']['output']>
  country: Location
  createdAt: Scalars['Time']['output']
  details: Scalars['String']['output']
  dueMonth: Maybe<ProjectDueMonth>
  dueYear: Maybe<Scalars['Int']['output']>
  externalId: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  lastUsedAt: Scalars['Time']['output']
  number: Scalars['String']['output']
  phase: Maybe<Phase>
  size: Maybe<IntRange>
  slug: Scalars['String']['output']
  spaces: Scalars['Int']['output']
  state: Maybe<Location>
  status: ProjectStatus
  timeline: Maybe<IntRange>
  title: Scalars['String']['output']
  type: Type
  updatedAt: Scalars['Time']['output']
  userRef: Scalars['String']['output']
}

export type ProjectCollection = {
  __typename?: 'ProjectCollection'
  currentPage: Scalars['Int']['output']
  items: Array<Project>
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ProjectContext = {
  __typename?: 'ProjectContext'
  canEdit: Scalars['Boolean']['output']
  project: TagProject
  sampledItem: Maybe<SampledItem>
}

export enum ProjectDueMonth {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  NotSure = 'NOT_SURE',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER',
}

export type ProjectInput = {
  budget: InputMaybe<IntRangeInput>
  city: InputMaybe<Scalars['String']['input']>
  country: InputMaybe<LocationInput>
  details: InputMaybe<Scalars['String']['input']>
  dueMonth: InputMaybe<ProjectDueMonth>
  dueYear: InputMaybe<Scalars['Int']['input']>
  phase: InputMaybe<Scalars['String']['input']>
  size: InputMaybe<IntRangeInput>
  spaces: InputMaybe<Scalars['Int']['input']>
  state: InputMaybe<LocationInput>
  status: InputMaybe<ProjectStatus>
  timeline: InputMaybe<IntRangeInput>
  title: InputMaybe<Scalars['String']['input']>
  type: InputMaybe<Scalars['String']['input']>
}

export enum ProjectSortableField {
  ArchivedAt = 'ARCHIVED_AT',
  CreatedAt = 'CREATED_AT',
  LastUsedAt = 'LAST_USED_AT',
  Title = 'TITLE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
}

export enum ProjectStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  OnHold = 'ON_HOLD',
}

export type ProjectUser = {
  __typename?: 'ProjectUser'
  email: Maybe<Scalars['String']['output']>
  firstName: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  imageUrl: Maybe<Scalars['String']['output']>
  inviteAccepted: Scalars['Boolean']['output']
  lastName: Maybe<Scalars['String']['output']>
  type: ProjectUserType
  userRef: Maybe<Scalars['String']['output']>
}

export enum ProjectUserType {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

export type Query = {
  __typename?: 'Query'
  SampledItems: SampledItemCollection
  SampledItemsCount: Scalars['Int']['output']
  _empty: Maybe<Scalars['String']['output']>
  brand: Maybe<Brand>
  brandConfig: BrandConfig
  brandRep: Maybe<BrandRep>
  brandRepByTagRef: BrandRep
  brands: Array<Brand>
  cart: Cart
  cartProjects: Array<CartProject>
  citiesPaginated: CityCollection
  constructorUserContext: ConstructorUserContext
  countries: Array<Country>
  countriesPaginated: CountryCollection
  currentUser: Maybe<CurrentUser>
  dashboard: Dashboard
  dashboardSearchSuggestions: Array<SearchSuggestion>
  dashboardTagProducts: Array<DashboardTagProduct>
  healthcheck: Maybe<Scalars['String']['output']>
  notes: Array<Note>
  orders: Array<Order>
  pairsWithProducts: PairsWithProductsResult
  phases: Array<Phase>
  productByVariantSkus: Maybe<ProductByVariantSkusResult>
  productReplacements: ProductReplacementCollection
  productSaveStatus: SaveStatus
  project: Project
  projectByExternalID: Project
  projectContext: Maybe<ProjectContext>
  projectUserSuggestions: Array<SuggestedProjectUser>
  projectUsers: Array<ProjectUser>
  projects: ProjectCollection
  sampledItemTags: Array<SampledItemTag>
  searchProducts: ProductSearchResult
  similarProducts: SimilarProductsResult
  tag: Maybe<Tag>
  tags: Maybe<Array<Maybe<Tag>>>
  taps: Array<Tap>
  types: Array<Type>
  variantAvailability: Array<VariantAvailability>
}

export type QuerySampledItemsArgs = {
  filter: InputMaybe<SampledItemsFilterInput>
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
  sortBy: InputMaybe<ItemSortableField>
  sortDirection: InputMaybe<ItemSortDirection>
}

export type QuerySampledItemsCountArgs = {
  filter: InputMaybe<SampledItemsFilterInput>
}

export type QueryBrandArgs = {
  brandRef: Scalars['String']['input']
}

export type QueryBrandConfigArgs = {
  brandRef: Scalars['String']['input']
}

export type QueryBrandRepArgs = {
  sku: InputMaybe<Scalars['String']['input']>
  tagRef: Scalars['String']['input']
}

export type QueryBrandRepByTagRefArgs = {
  tagRef: Scalars['String']['input']
}

export type QueryBrandsArgs = {
  params: InputMaybe<CollectionParams>
}

export type QueryCitiesPaginatedArgs = {
  countryCodes: InputMaybe<Array<Scalars['String']['input']>>
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
  query: InputMaybe<Scalars['String']['input']>
  stateCodes: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryCountriesArgs = {
  codes: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryCountriesPaginatedArgs = {
  codes: InputMaybe<Array<Scalars['String']['input']>>
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
}

export type QueryDashboardArgs = {
  input: DashboardInput
}

export type QueryDashboardSearchSuggestionsArgs = {
  input: SearchSuggestionInput
}

export type QueryDashboardTagProductsArgs = {
  input: DashboardTagProductsInput
}

export type QueryNotesArgs = {
  projectID: Scalars['UUID']['input']
}

export type QueryPairsWithProductsArgs = {
  locale: InputMaybe<Scalars['String']['input']>
  resultsPerPage: InputMaybe<Scalars['Int']['input']>
  sku: Scalars['String']['input']
}

export type QueryProductByVariantSkusArgs = {
  locale: InputMaybe<Scalars['String']['input']>
  skus: Array<Scalars['String']['input']>
}

export type QueryProductReplacementsArgs = {
  brandRef: Scalars['String']['input']
  filters: InputMaybe<ProductReplacementCollectionFilters>
  orderBy: InputMaybe<ProductReplacementOrderBy>
  orderDirection: InputMaybe<SortOrder>
  params: InputMaybe<CollectionParams>
}

export type QueryProductSaveStatusArgs = {
  variantSku: Scalars['String']['input']
}

export type QueryProjectArgs = {
  slug: Scalars['String']['input']
}

export type QueryProjectByExternalIdArgs = {
  externalID: Scalars['Int']['input']
}

export type QueryProjectContextArgs = {
  productRef: Scalars['String']['input']
  projectExternalId: Scalars['Int']['input']
}

export type QueryProjectUserSuggestionsArgs = {
  limit: Scalars['Int']['input']
  projectID: Scalars['UUID']['input']
}

export type QueryProjectUsersArgs = {
  projectID: Scalars['UUID']['input']
}

export type QueryProjectsArgs = {
  excludedStatuses: InputMaybe<Array<ProjectStatus>>
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
  sortBy: InputMaybe<ProjectSortableField>
  sortDirection: InputMaybe<SortDirection>
  statuses: InputMaybe<Array<ProjectStatus>>
}

export type QuerySampledItemTagsArgs = {
  projectID: Scalars['UUID']['input']
}

export type QuerySearchProductsArgs = {
  brandName: InputMaybe<Scalars['String']['input']>
  exclude: InputMaybe<Array<Scalars['String']['input']>>
  locale: InputMaybe<Scalars['String']['input']>
  page: InputMaybe<Scalars['Int']['input']>
  pageSize: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QuerySimilarProductsArgs = {
  categoryGroupIds: InputMaybe<Array<Scalars['String']['input']>>
  locale: InputMaybe<Scalars['String']['input']>
  resultsPerPage: InputMaybe<Scalars['Int']['input']>
  sku: Scalars['String']['input']
  variationSku: InputMaybe<Scalars['String']['input']>
}

export type QueryTagArgs = {
  tagRef: Scalars['String']['input']
}

export type QueryTapsArgs = {
  fingerprint: InputMaybe<Scalars['UUID']['input']>
}

export type QueryTypesArgs = {
  companyType: InputMaybe<Scalars['String']['input']>
}

export type QueryVariantAvailabilityArgs = {
  locale: InputMaybe<Scalars['String']['input']>
  productSku: Scalars['String']['input']
}

export type RecordTapInput = {
  fingerprint: Scalars['UUID']['input']
  location: InputMaybe<CoordinatesInput>
  nonce: Scalars['String']['input']
  tagRef: Scalars['String']['input']
}

export type RecordTapResponse = {
  __typename?: 'RecordTapResponse'
  tag: Tag
  tap: Tap
}

export type Region = {
  __typename?: 'Region'
  Subregions: Array<Subregion>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export enum Role {
  RoleAdmin = 'ROLE_ADMIN',
  RoleUser = 'ROLE_USER',
}

export type SampledItem = {
  __typename?: 'SampledItem'
  associatedProductRef: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  permissions: SampledItemPermissions
  product: Product
  shippedAt: Scalars['Time']['output']
  status: ItemStatus
  tags: Array<SampledItemTag>
  updatedAt: Scalars['Time']['output']
}

export type SampledItemCollection = {
  __typename?: 'SampledItemCollection'
  currentPage: Scalars['Int']['output']
  filters: SampledItemsFilters
  items: Array<SampledItem>
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type SampledItemPermissions = {
  __typename?: 'SampledItemPermissions'
  canEdit: Scalars['Boolean']['output']
}

export type SampledItemTag = {
  __typename?: 'SampledItemTag'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type SampledItemsFilterInput = {
  brands: InputMaybe<Array<Scalars['String']['input']>>
  categories: InputMaybe<Array<Scalars['String']['input']>>
  productRefs: InputMaybe<Array<Scalars['String']['input']>>
  projectRefs: InputMaybe<Array<Scalars['String']['input']>>
  statuses: InputMaybe<Array<ItemStatus>>
  tags: InputMaybe<Array<Scalars['String']['input']>>
}

export type SampledItemsFilters = {
  __typename?: 'SampledItemsFilters'
  brands: Array<Scalars['String']['output']>
  categories: Array<Scalars['String']['output']>
  productRefs: Array<Scalars['String']['output']>
  projectRefs: Array<Scalars['String']['output']>
  statuses: Array<ItemStatus>
  tags: Array<Scalars['String']['output']>
}

export type SaveStatus = {
  __typename?: 'SaveStatus'
  folderIds: Array<Scalars['ID']['output']>
  isSaved: Scalars['Boolean']['output']
}

export type SearchSuggestion =
  | AddressSuggestion
  | MemberSuggestion
  | ProductSuggestion

export type SearchSuggestionInput = {
  brandRef: Scalars['String']['input']
  limit: Scalars['Int']['input']
  query: Scalars['String']['input']
  timeframe: TimeframeInput
}

export type SearchedProduct = {
  __typename?: 'SearchedProduct'
  exactColor: Maybe<Scalars['String']['output']>
  imageUrl: Scalars['String']['output']
  name: Scalars['String']['output']
  productRef: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type SimilarProduct = {
  __typename?: 'SimilarProduct'
  brand: Maybe<Scalars['String']['output']>
  groupId: Maybe<Scalars['String']['output']>
  hoverImage: Maybe<SimilarProductImage>
  id: Scalars['String']['output']
  imageUrl: Scalars['String']['output']
  installImageUrl: Maybe<Scalars['String']['output']>
  isOutOfStock: Scalars['Boolean']['output']
  mainImage: Maybe<SimilarProductImage>
  name: Scalars['String']['output']
  searchHexCode: Maybe<Scalars['String']['output']>
}

export type SimilarProductImage = {
  __typename?: 'SimilarProductImage'
  label: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type SimilarProductsResult = {
  __typename?: 'SimilarProductsResult'
  products: Array<SimilarProduct>
  totalCount: Scalars['Int']['output']
}

/** Reusable sorting definitions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type State = {
  __typename?: 'State'
  cities: Array<City>
  code: Maybe<Scalars['String']['output']>
  countryCode: Scalars['String']['output']
  countryId: Scalars['Int']['output']
  fipsCode: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  latitude: Maybe<Scalars['Float']['output']>
  longitude: Maybe<Scalars['Float']['output']>
  name: Scalars['String']['output']
  type: Maybe<Scalars['String']['output']>
}

export type Subregion = {
  __typename?: 'Subregion'
  Countries: Array<Country>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type Subscription = {
  __typename?: 'Subscription'
  _empty: Maybe<Scalars['String']['output']>
  dashboardUpdated: Dashboard
  healthcheck: Maybe<Scalars['Boolean']['output']>
}

export type SubscriptionDashboardUpdatedArgs = {
  input: DashboardInput
  throttleMs: InputMaybe<Scalars['Int']['input']>
}

export type SuggestedProjectUser = {
  __typename?: 'SuggestedProjectUser'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type Tag = {
  __typename?: 'Tag'
  brandConfig: BrandConfig
  brandId: Scalars['UUID']['output']
  brandRef: Scalars['String']['output']
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  product: Maybe<ProductByVariantSkusResult>
  productRef: Scalars['String']['output']
  projectRef: Scalars['String']['output']
  replacementRef: Maybe<Scalars['String']['output']>
  replacementType: TagReplacementType
  status: TagStatus
  tagRef: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type TagProductArgs = {
  locale: InputMaybe<Scalars['String']['input']>
}

export type TagPin = {
  __typename?: 'TagPin'
  city: Scalars['String']['output']
  coordinates: Coordinates
  country: Scalars['String']['output']
  state: Scalars['String']['output']
  status: TagStatus
  tagRef: Scalars['String']['output']
}

export type TagProject = {
  __typename?: 'TagProject'
  externalId: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  slug: Scalars['String']['output']
  status: ProjectStatus
  title: Scalars['String']['output']
}

export enum TagReplacementType {
  NotApplicable = 'NOT_APPLICABLE',
  Product = 'PRODUCT',
  RedirectUrl = 'REDIRECT_URL',
}

export enum TagStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type Tap = {
  __typename?: 'Tap'
  address: Maybe<Address>
  createdAt: Scalars['Time']['output']
  fingerprint: Scalars['UUID']['output']
  id: Scalars['UUID']['output']
  ip: Scalars['String']['output']
  location: Maybe<Location>
  nonce: Scalars['String']['output']
  tagId: Scalars['UUID']['output']
  userRef: Maybe<Scalars['String']['output']>
}

export type TimeframeInput = {
  from: Scalars['Time']['input']
  to: InputMaybe<Scalars['Time']['input']>
}

export type TopProduct = {
  __typename?: 'TopProduct'
  color: Scalars['String']['output']
  count: Scalars['Int']['output']
  delta: Scalars['Float']['output']
  image: Scalars['String']['output']
  name: Scalars['String']['output']
  productRef: Scalars['String']['output']
}

export type Type = {
  __typename?: 'Type'
  buildingType: Scalars['String']['output']
  code: Scalars['String']['output']
  externalId: Scalars['Int']['output']
  industrySectorsPrimary: Array<Scalars['String']['output']>
  industrySectorsSecondary: Array<Scalars['String']['output']>
  label: Scalars['String']['output']
}

export type TypeInput = {
  code: Scalars['String']['input']
  label: InputMaybe<Scalars['String']['input']>
}

export type UpdateCartItemInput = {
  itemId: Scalars['ID']['input']
  projectId: InputMaybe<Scalars['ID']['input']>
  quantity: InputMaybe<Scalars['Int']['input']>
}

export type UpdateProductReplacementInput = {
  productRef: Scalars['String']['input']
  replacementRef: InputMaybe<Scalars['String']['input']>
  replacementType: ProductReplacementType
}

export type UpdateProjectUser = {
  type: InputMaybe<ProjectUserType>
}

export type UpdateSampledItemInput = {
  status: InputMaybe<ItemStatus>
  tagNames: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateTapLocationInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
  tapId: Scalars['UUID']['input']
}

export type UpdateTapLocationResponse = {
  __typename?: 'UpdateTapLocationResponse'
  success: Scalars['Boolean']['output']
}

export type VariantAvailability = {
  __typename?: 'VariantAvailability'
  availableQuantity: Scalars['Int']['output']
  isOnStock: Scalars['Boolean']['output']
  sku: Scalars['String']['output']
}
